/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExcelPlanResponse } from '../models/ExcelPlanResponse';
import type { ForceCheckoutReleaseResponse } from '../models/ForceCheckoutReleaseResponse';
import type { GenerateExcelResponse } from '../models/GenerateExcelResponse';
import type { GenerateXMLRequest } from '../models/GenerateXMLRequest';
import type { GenerateXMLResponse } from '../models/GenerateXMLResponse';
import type { OptimizePlanRequest } from '../models/OptimizePlanRequest';
import type { OptimizePlanResponse } from '../models/OptimizePlanResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductionPlanService {
    /**
     * 選択中ファイルからの生産計画作成
     * 選択中のファイルから生産計画を作成するエンドポイント
     * @param force セッション中の生産計画を破棄
     * @returns ExcelPlanResponse Successful Response
     * @throws ApiError
     */
    public static createProductionPlan(
        force?: number,
    ): CancelablePromise<ExcelPlanResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-plan/selected',
            query: {
                'force': force,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Optimize
     * planを送信すると在庫とcapacityを計算して返すエンドポイント
     * @param requestBody
     * @returns OptimizePlanResponse Successful Response
     * @throws ApiError
     */
    public static optimize(
        requestBody: OptimizePlanRequest,
    ): CancelablePromise<OptimizePlanResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/optimize',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 生産計画XMLファイル生成
     * 生産計画データからXMLファイルを生成し、ダウンロード可能なURLを返すエンドポイント
     * @param requestBody
     * @returns GenerateXMLResponse Successful Response
     * @throws ApiError
     */
    public static generateXml(
        requestBody: GenerateXMLRequest,
    ): CancelablePromise<GenerateXMLResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/generate-xml',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * 生産計画Excelファイル生成
     * 選択中のExcelファイルを基に生産計画データを書き込み、ダウンロードURLを返します
     * @param requestBody
     * @returns GenerateExcelResponse Successful Response
     * @throws ApiError
     */
    public static generateExcel(
        requestBody: GenerateXMLRequest,
    ): CancelablePromise<GenerateExcelResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/generate-excel',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * OneDriveチェックアウトのみ実行
     * 選択中のOneDriveファイルに対してチェックアウトのみを実行します（デバッグ用）
     * @returns ForceCheckoutReleaseResponse Successful Response
     * @throws ApiError
     */
    public static checkoutOnly(): CancelablePromise<ForceCheckoutReleaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/checkout-only',
        });
    }
    /**
     * OneDriveチェックアウト強制解除
     * 選択中のOneDriveファイルに対してチェックアウト状態を強制解除します
     * @returns ForceCheckoutReleaseResponse Successful Response
     * @throws ApiError
     */
    public static forceReleaseCheckout(): CancelablePromise<ForceCheckoutReleaseResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-plan/force-release-checkout',
        });
    }
}
